module.exports = __webpack_public_path__ + "static/12-96010dc7eadfcb4778ee30b691036dca.jpg";